import axios from 'axios';
import { refreshAccessToken } from './auth';

console.log('API Base URL:', process.env.REACT_APP_API_BASE_URL_PROD);

const baseURL = 
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_BASE_URL_PROD
    : process.env.REACT_APP_API_BASE_URL;

console.log('Using API Base URL:', baseURL); // 🐛 Helpful for debugging!

const api = axios.create({
  baseURL,
});

api.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
        config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response.status === 403 && !error.config._retry) {
            error.config._retry = true;
            const newAccessToken = await refreshAccessToken();
            error.config.headers['Authorization'] = `Bearer ${newAccessToken}`;
            return api(error.config);
        }
        return Promise.reject(error);
    }
);

export default api;